import React, { useState, useEffect, useCallback, Fragment } from 'react'
import { usePromiseTracker } from 'react-promise-tracker'

import { debounce } from 'lodash'
import moment from 'moment'

import {
  TextField,
  Menu,
  MenuItem,
  InputAdornment,
  Select,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  IconButton
} from '@mui/material'

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import services from '../../services'

import { ICargo } from '../../interfaces/index'
import { useAuth } from '../../hooks/useAuth'

interface ITableaUsuario {
  mainList: ICargo[] | [] | null | undefined
  editRegistro: any
  handleRemoverRegistro:any
  handlePagination: any
  handleBusca:any

  currentPage: number
  totalPages: number
  pageSize: number
}

function TabelaCargos(props: ITableaUsuario) {
  const { 
    mainList, editRegistro, handleBusca, pageSize, 
    handleRemoverRegistro, currentPage, totalPages, handlePagination
  } = props;

  const { promiseInProgress } = usePromiseTracker()
  const { getUserRoles } = useAuth()
  const userRoles = getUserRoles()
  
  const [anchorElBusca, setAnchorElBusca] = useState<null | HTMLElement>(null);
  const openBusca = Boolean(anchorElBusca);
  const handleClickBusca = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElBusca(event.currentTarget);
  };
  const handleCloseBusca = () => {
    setAnchorElBusca(null);
  };

  const [filterList, setFilterList] = useState<any>(null)
  const [search, setSearch] = useState('')

  const [colunaAtiva] = useState<string>('')
  const [colunaBusca, setColunaBusca] = useState<string>('name&&&')
  const [paginacao, setPaginacao] = useState<number[] | []>([])

  const ativaOrdenacao = true

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleBuscaDebounce = useCallback(debounce((busca) => {
    handleBusca(colunaBusca + busca, pageSize)
  }, 800),  [colunaBusca, pageSize])

  const handleChangeBusca = (busca:string) => {
    setSearch(busca)
    handleBuscaDebounce(busca)
  }

  const ordeby = (direction: boolean, column?: string) => {
    if (column) {
      handleBusca(colunaBusca + search, pageSize, column, direction)
    } else {
      handleBusca(colunaBusca + search, pageSize, colunaAtiva, direction)
    }
  }

  useEffect(() => {
    setFilterList(mainList?.map((item:ICargo) => {
      item.selecionado = false
      return item
    }))
  }, [mainList])

  useEffect(() => {
    setPaginacao(services.utils.getPaginationItens(totalPages, currentPage))
  }, [totalPages, currentPage])

  return (
    <>
      <div className='wrapper-page-content-interna'>
        <div className='flex items-center justify-between gap-10'>
          <div className='flex gap-10'></div>
          <div className='flex items-center gap-10'>
            <div className='flex items-center gap-6'>
              <TextField
                size='small'
                className='w-200'
                label='Pesquisa'
                placeholder='Pesquisa'
                inputProps={{ maxLength: 50 }}
                value={search}
                onChange={e => handleChangeBusca(e.target.value)}
                disabled={promiseInProgress}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        style={{backgroundColor: '#E21AE7', color: 'white', padding: '2px', marginRight: '-8px', borderRadius: '4px'}}
                        aria-label="toggle password visibility"
                        onClick={(e) => handleClickBusca(e)}
                        edge="end"
                      >
                        <FilterAltIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
          </div>
        </div>
        <div className='divider' style={{opacity: 0}}></div>
        <div className='table-container'>
          <table>
            <thead>
              <tr>
                <th>
                  <div>
                    <span className='th-title'><BadgeOutlinedIcon fontSize="inherit" />Nome</span>
                    {ativaOrdenacao &&
                      <div style={{display:'flex', flexDirection: 'column'}}>
                        <IconButton  
                          size="small" 
                          onClick={() => ordeby(false,'name')}
                          style={{padding:'2px'}}
                          disabled={promiseInProgress}
                        >
                          <ArrowUpwardIcon style={{fontSize: '12px'}}  />
                          
                        </IconButton>
                        <IconButton  
                          size="small" 
                          onClick={() => ordeby(true,'name')}
                          style={{padding:'2px'}}
                          disabled={promiseInProgress}
                        >
                          <ArrowDownwardIcon style={{fontSize: '12px'}}  />
                        </IconButton>
                      </div>
                    }
                  </div>
                </th>
                <th>
                  <div>
                    <span className='th-title'> Descrição</span>
                    {ativaOrdenacao &&
                      <div style={{display:'flex', flexDirection: 'column'}}>
                        <IconButton  
                          size="small" 
                          onClick={() => ordeby(false,'description')}
                          style={{padding:'2px'}}
                          disabled={promiseInProgress}
                        >
                          <ArrowUpwardIcon style={{fontSize: '12px'}}  />
                          
                        </IconButton>
                        <IconButton  
                          size="small" 
                          onClick={() => ordeby(true,'description')}
                          style={{padding:'2px'}}
                          disabled={promiseInProgress}
                        >
                          <ArrowDownwardIcon style={{fontSize: '12px'}}  />
                        </IconButton>
                      </div>
                    }
                  </div>
                </th>
                <th>
                  <div>
                    <span className='th-title'> Função Superior</span>
                    {ativaOrdenacao &&
                      <div style={{display:'flex', flexDirection: 'column'}}>
                        <IconButton  
                          size="small" 
                          onClick={() => ordeby(false,'parentFunctionName')}
                          style={{padding:'2px'}}
                          disabled={promiseInProgress}
                        >
                          <ArrowUpwardIcon style={{fontSize: '12px'}}  />
                          
                        </IconButton>
                        <IconButton  
                          size="small" 
                          onClick={() => ordeby(true,'parentFunctionName')}
                          style={{padding:'2px'}}
                          disabled={promiseInProgress}
                        >
                          <ArrowDownwardIcon style={{fontSize: '12px'}}  />
                        </IconButton>
                      </div>
                    }
                  </div>
                </th>
                <th>
                  <div>
                    <span className='th-title'><LocalOfferOutlinedIcon fontSize="inherit" /> Criado em</span>
                    {ativaOrdenacao &&
                      <div style={{display:'flex', flexDirection: 'column'}}>
                        <IconButton  
                          size="small" 
                          onClick={() => ordeby(false,'createdAt')}
                          style={{padding:'2px'}}
                          disabled={promiseInProgress}
                        >
                          <ArrowUpwardIcon style={{fontSize: '12px'}}  />
                          
                        </IconButton>
                        <IconButton  
                          size="small" 
                          onClick={() => ordeby(true,'createdAt')}
                          style={{padding:'2px'}}
                          disabled={promiseInProgress}
                        >
                          <ArrowDownwardIcon style={{fontSize: '12px'}}  />
                        </IconButton>
                      </div>
                    }
                  </div>
                </th>
                {(userRoles.includes('function_update') || userRoles.includes('function_delete')) &&
                  <th><div><span className='th-title'>Ações</span></div></th>
                }
              </tr>
            </thead>
            <tbody>
              {!filterList && 
                <tr><td colSpan={5}><div className='justify-center'>loading...</div></td></tr>
              }
              {filterList?.length === 0 && 
                <tr><td colSpan={5}><div className='justify-center'>Nenhum registro encontrado</div></td></tr>
              }
              {filterList?.map((item: ICargo, index: number) => (
                <tr key={item.id}>
                  <td><div>{item.name}</div></td>
                  <td><div>{item.description}</div></td>
                  <td><div>{item.parentFunctionName}</div></td>
                  <td><div>{item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY HH:mm') : '-'}</div></td>
                  {(userRoles.includes('function_update') || userRoles.includes('function_delete')) &&
                    <td>
                      <div className='justify-start'>
                        {userRoles.includes('function_update') &&
                          <IconButton  
                            size="small" aria-label="editar usuário" component="label" 
                            onClick={() => editRegistro(item)}
                            disabled={promiseInProgress}
                          >
                            <ModeEditOutlineOutlinedIcon fontSize="small" />
                          </IconButton>
                        }
                        {userRoles.includes('function_delete') &&
                          <IconButton  
                            size="small" aria-label="editar usuário" component="label" 
                            onClick={() => handleRemoverRegistro(item)}
                            disabled={promiseInProgress}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        }
                      </div>
                    </td>
                  }
                </tr>
              ))}
            </tbody>
          </table>

          {currentPage && filterList?.length ?
            <div className='flex justify-end items-center gap-10'>
              <div className='table-pagination'>
                <IconButton 
                  size="small" aria-label="primeira pagina" component="label" 
                  onClick={() => handlePagination(1, colunaBusca + search, pageSize )}
                  disabled={promiseInProgress || currentPage <= 1}
                >
                  <KeyboardDoubleArrowLeftIcon />
                </IconButton>
                <IconButton 
                  size="small" aria-label="pagina anterior" component="label" 
                  onClick={() => handlePagination(currentPage - 1, colunaBusca + search, pageSize )}
                  disabled={promiseInProgress || currentPage <= 1}
                >
                  <KeyboardArrowLeftIcon />
                </IconButton>
                {paginacao?.map(page => (
                  <Fragment key={page.toString()}>
                    {page === currentPage ? <div className='table-pagination_number active'>{page.toString()}</div> : 
                    <IconButton 
                      className='table-pagination_number'
                      size="small" aria-label="Próxima pagina" component="label" 
                      onClick={() => handlePagination(page, colunaBusca + search, pageSize )}
                    >
                      {page.toString()}
                    </IconButton>
                   }
                  </Fragment>
                ))}
                <IconButton 
                  size="small" aria-label="Próxima pagina" component="label" 
                  onClick={() => handlePagination(currentPage + 1, colunaBusca + search, pageSize )}
                  disabled={promiseInProgress || currentPage >= totalPages}
                >
                  <KeyboardArrowRightIcon />
                </IconButton>
                <IconButton 
                  size="small" aria-label="ultima pagina" component="label" 
                  onClick={() => handlePagination(totalPages, colunaBusca + search, pageSize )}
                  disabled={promiseInProgress || currentPage >= totalPages}
                >
                  <KeyboardDoubleArrowRightIcon />
                </IconButton>
              </div>
              <Select
                style={{width: '100px'}}
                fullWidth
                size="small"
                value={pageSize || ''}
                disabled={promiseInProgress}
                onChange={e =>
                  handlePagination(1, colunaBusca + search, e.target.value )
                }
              >
                <MenuItem value="10">10 Itens</MenuItem>
                <MenuItem value="20">20 Itens</MenuItem>
                <MenuItem value="50">50 Itens</MenuItem>
                <MenuItem value="100">100 Itens</MenuItem>
              </Select>
            </div> : ''
          }
        </div>
      </div>

      {/* menu opções busca */}
      <Menu
        anchorEl={anchorElBusca}
        open={openBusca}
        onClose={handleCloseBusca}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          },
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <div>
          <div style={{padding: '2px 8px', fontSize: '14px'}}>
            Buscar por
          </div>
          <div style={{padding: '2px 8px'}}>
            <FormControl>
              <RadioGroup
                aria-labelledby="tipoBuscaColunaBusca-label"
                name="tipoBuscaColunaBusca"
                onChange={e => setColunaBusca(e.target.value)}
                value={colunaBusca}
              >
                <FormControlLabel value="name&&&" control={<Radio />} label="Nome" />
                <FormControlLabel value="description&&&" control={<Radio />} label="Descrição" />
              </RadioGroup>
            </FormControl>   
          </div>
        </div>
        
      </Menu>
    </>
  )
}

export default TabelaCargos
